import { useMelwaysInfo } from '@seek/melways-react';
import type { SupportedProduct } from '@seek/online-identity';
import { useCallback } from 'react';

import { getAuthN as authnSingleton } from '../authSingleton/index';

export const useCrossProductTransitionUrl = (product: SupportedProduct) => {
  const { locale } = useMelwaysInfo();

  const transformCrossProductTransitionUrl = useCallback(
    async (originalUrl: string): Promise<string> => {
      if (!originalUrl) {
        return originalUrl;
      }

      try {
        const authN = await authnSingleton();
        const transitionHandler = authN.transitionHandler;

        // Extract the domain and path from the original URL
        const url = new URL(originalUrl);
        const domain = url.host;

        // Construct the redirect URL with existing query parameters
        const redirectTo = url.toString();

        // Create the cross-product transition URL
        const transitionUrl = await transitionHandler.createUrl({
          product,
          domain,
          redirectTo,
          queryParams: {
            language: locale,
          },
        });

        return transitionUrl;
      } catch {
        // Return original URL if transformation fails
        return originalUrl;
      }
    },
    [locale, product],
  );

  return transformCrossProductTransitionUrl;
};
